import React from "react";
import {connect} from "react-redux";
import {Lot} from "@nextlot/core/webcast/data/data_types_definitions";
import {ROUND_TYPES_MAP} from "@nextlot/core/webcast/data/WebcastDataDomain";
import {ReduxWebcastCurrentRoundType} from "@nextlot/core/webcast/redux/webcast/reducerWebcastCurrentRound";
import {ReduxStateType} from "@nextlot/core/webcast/services/DataStore";


type CurrentRoundLotListItemPropsType = {
    lot: Partial<Lot>
}

const CurrentRoundLotListItem = (props:CurrentRoundLotListItemPropsType) => {
    const { lot } = props;

    return (
        <li className="list-group-item d-flex flex-row align-items-center ps-0">
            <img src={lot.defaultImageSmUrl} className="list-item__image" alt={`Lot #${lot.number}`} width={60}/>
            <div className="pe-2 border-end fw-bold text-end" style={{ width: 60 }}>{lot.number}</div>
            <div className="ps-2 font-weight-light text-nowrap overflow-hidden">{lot.name}</div>
        </li>
    )
};





type ClerkCurrentRoundCmpPropsType = {
    webcastCurrentRound: ReduxWebcastCurrentRoundType,

    lotsMapById: Map<number, Lot>,
};

const ClerkCurrentRoundCmp = (props:ClerkCurrentRoundCmpPropsType) => {
    return (
        <div className="card mt-1 flex-grow-1">
            <div className="card-header bg-light">
                Round: {ROUND_TYPES_MAP.get(props.webcastCurrentRound.roundType)} [{props.webcastCurrentRound.lotsIds.length}]
            </div>
            <div className="card-body position-relative">
                <div className="position-absolute overflow-auto" style={{ top: 0, right: 0, bottom: 0, left: 0 }}>
                    <ul className="list-group list-group-flush">
                        {props.webcastCurrentRound.lotsIds.map ((lotId) => {
                            const lot = props.lotsMapById.get(lotId);
                            return <CurrentRoundLotListItem key={lotId} lot={lot} />
                        })}
                    </ul>
                </div>
            </div>
        </div>
    )
};







export default connect(({ activeWebcast }:ReduxStateType) => {
    return {
        webcastCurrentRound: activeWebcast.webcastCurrentRound,
        lotsMapById: activeWebcast.webcastAuctionData.lotsMapById
    };
})(ClerkCurrentRoundCmp);
